import React, { useState, useEffect, useRef, forwardRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Styles.css";
import AOS from "aos";
import "aos/dist/aos.css";
import gif1 from "../assets/landing1.gif";
import gif2 from "../assets/landing2.gif";
import gif3 from "../assets/landing3.gif";

const GetInTouch = forwardRef((props, ref) => {
  const [gifSrc, setGifSrc] = useState(gif1);
  const textRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [activeButton, setActiveButton] = useState("AI");

  const handleClick = (type) => {
    setActiveButton(type);
    if (type === "AI") setGifSrc(gif1);
    if (type === "Training") setGifSrc(gif2);
    if (type === "Homework") setGifSrc(gif3);
  };

  const buttonDescriptions = {
    AI: "It’s the promise of constant support, guidance, and connection. Whether it’s helping you stay productive, lifting your mood, sparking creativity, or simply being there to listen, your companion is always by your side.",
    Training: "Always ready to push you closer to your goals, motivate you when it gets tough, and celebrate every little win along the way.",
    Homework: "Your friendly partner in learning, always ready to simplify tough concepts, guide you through assignments, and make studying less stressful.",
  };

  // Intersection Observer for text animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.5 }
    );
    if (textRef.current) observer.observe(textRef.current);
    return () => {
      if (textRef.current) observer.unobserve(textRef.current);
    };
  }, []);

  // Initialize AOS
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="container" ref={ref}>
      <div
        className="d-flex flex-row flex-wrap justify-content-center align-items-start outer-container"
        data-aos="fade-up"
      >
        {/* Left Buttons Column */}
        <div className="buttons-column" data-aos="fade-right" data-aos-delay="100">
          <div
            ref={textRef}
            className={`futuristic-text ${isVisible ? "animate" : ""}`}
            data-aos="fade-down"
            data-aos-delay="200"
          >
            Your AI <span className="highlight">Future Awaits...</span>
          </div>

          {["AI", "Training", "Homework"].map((type) => (
            <div className="button-wrapper" key={type} data-aos="fade-up" data-aos-delay={300}>
              <button
                className={`gradient-btn ${activeButton === type ? "active" : ""}`}
                onClick={() => handleClick(type)}
              >
                {type === "AI"
                  ? "Your AI Companion"
                  : type === "Training"
                  ? "Your Training Buddy"
                  : "Homework Companion"}
              </button>
              {activeButton === type && (
                <p className="hover-description show">{buttonDescriptions[type]}</p>
              )}
            </div>
          ))}
        </div>

        {/* Right GIF Column */}
        <div className="phone-frame" data-aos="zoom-in" data-aos-delay="400">
          <img src={gifSrc} alt="Animated content" className="phone-video" />
        </div>
      </div>
    </div>
  );
});

export default GetInTouch;
